import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { GridApi, ColumnApi, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Utilities } from 'src/app/models/utilities';
import { AppCoreService } from 'src/app/services/app-core.service';
import { JobService } from 'src/app/services/job.service';
import { JOBQueueStatusRenderer } from '../shared/ag-grid/cell-renderers/JOBQueueStatusRenderer';
import { JobsErrorComponent } from './jobs-error/jobs-error.component';
import { JobsValidationComponent } from './jobs-validation/jobs-validation.component';
import { FileHandlerService } from 'src/app/services/file-handler.service';
import { saveAs } from 'file-saver-es';
@Component({
  selector: 'app-jobs',
  templateUrl: './jobs.component.html',
  styleUrls: ['./jobs.component.scss']
})
export class JobsComponent {

  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };

  rowDataJobQueue = [];
  userData: any;
  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  public context: any;

  gridOptions: GridOptions = {
    pagination: true,
    paginationPageSize: 10,
    domLayout: 'autoHeight',
  }

  defaultColDef = {
    filter: true,
    sortable: true,
    resizable: false,
    flex: 1,
    minWidth: 120,
  };

  columnDefsJobQueue = [
    { headerName: 'Job Type ', field: 'jobtype', filter: true },
    { headerName: 'Job Category ', field: 'jobcategory', filter: true },
    { headerName: 'Job Description ', field: 'jobdescription', filter: true, minWidth: 200 },
    { headerName: 'Initiated By ', field: 'initiatedby', filter: true },
    {
      headerName: 'Initiated At ',
      field: 'initiatedat',
      filter: true,
      cellRenderer: (params: any) => {
        if (params.value) {
          return this.utilities.FormatDateWithTime(0, params.value).dateTimeStringAMPM
        }
        return '';
      }
    },
    {
      headerName: 'Job Status',
      field: 'jobstatus',
      filter: true,
      minWidth: 120,
      pinned: 'right',
      cellRenderer: (params: { value: string; data?: { jobcategory?: string; }; }) => {
        let statusHtml = `<span class="badge bg-light">${params.value}</span>`;
        if (params.value === 'ACTIVE') {
          statusHtml = `<span class="badge bg-info">ACTIVE</span>`;
        }
        if (params.value === 'COMPLETED') {
          statusHtml = `<span class="badge bg-success">COMPLETED</span>`;
          if (params.data?.jobcategory === 'AWB' || params.data?.jobcategory === 'POD') {
            statusHtml = `
              <span class="badge bg-success">COMPLETED</span>
              <button class="btn btn-sm btn-primary ms-2 py-0 px-1 mb-1 download-btn">Download</button>`;
          }
        } else if (params.value === 'TIMEDOUT') {
          statusHtml = `<span class="badge bg-warning">TIMEDOUT</span>`;
        } else if (params.value === 'FAILED') {
          statusHtml = `<span class="badge bg-danger">FAILED</span>`;
        } else {
          statusHtml = `<span class="badge bg-secondary">${params.value.split('_')[1] || params.value}</span>`;
        }
        return statusHtml;
      }
      
    },
    {
      headerName: 'Processing Status',
      field: 'processingstatus',
      filter: true,
      minWidth: 200,
      pinned: 'right',
      cellRenderer: (params: { value: string; }) => {
        let statusHtml = `<span class="badge bg-light">${params.value}</span>`;
        if (params.value === 'RUNNING') {
          statusHtml = `<span class="badge bg-info">RUNNING</span>`;
        } else if (params.value === 'VALIDATING') {
          statusHtml = `<span class="badge bg-primary">VALIDATING</span>`;
        } else if (params.value === 'VALIDATION COMPLETED') {
          statusHtml = `<span class="badge bg-success">VALIDATION COMPLETED</span>`;
        } else if (params.value === 'VALIDATION ERROR') {
          statusHtml = `<span class="badge bg-danger">VALIDATION ERROR</span>`;
        } else if (params.value === 'VALIDATION COMPLETED WITH ERROR') {
          statusHtml = `<span class="badge bg-danger">VALIDATION COMPLETED WITH ERROR</span>`;
        } else if (params.value === 'PROCESSING') {
          statusHtml = `<span class="badge bg-warning">PROCESSING</span>`;
        } else if (params.value === 'PROCESSING ERROR') {
          statusHtml = `<span class="badge bg-danger">PROCESSING ERROR</span>`;
        } else if (params.value === 'PROCESSED') {
          statusHtml = `<span class="badge bg-success">PROCESSED</span>`;
        } else {
          statusHtml = `<span class="badge bg-secondary">${params.value.split('_')[1] || params.value}</span>`;
        }
        return statusHtml;
      }
    },
    {
      headerName: 'Status',
      field: 'processingstatus',
      colId: 'params',
      filter: false,
      sortable: true,
      pinned: 'right',
      maxWidth: 70,
      cellRenderer: JOBQueueStatusRenderer
    },
  ];

  constructor(
    private _fb: FormBuilder,
    private appCoreService: AppCoreService,
    private ngxLoaderService: NgxUiLoaderService,
    private jobService: JobService,
    private modalService: NgbModal,
    private utilities: Utilities,
    private titleService: Title,
    private fileHandlerService: FileHandlerService,
  ) {
    titleService.setTitle('Jobs');
    this.context = { componentParent: this };
  }

  ngOnInit() {
    this.checkPermission();
    if (this.permConfig.isViewAllowed) {
      this.appCoreService.SelectedServiceCenter().subscribe(async (val) => { 
        this.bindJobList();
      });
    }
  }

  checkPermission(): any {
    this.userData = this.appCoreService.GetUserData();
    const permission = this.userData.config.filter(x => x.categoryname === 'Jobs');
    // console.log("permission", this.userData.config);
    if (permission.length) {
      this.permConfig.isViewAllowed = permission[0].view;
      this.permConfig.isAddAllowed = permission[0].add;
      this.permConfig.isEditAllowed = permission[0].edit;
      this.permConfig.isDeleteAllowed = permission[0].delete;
    }
  }

  onCellClicked(event: any): void {
    if (
      event.colDef.field === 'jobstatus' &&
      event.event?.target?.classList.contains('download-btn')
    ) {
      this.downloadFile(event);
    }
  }

  
  async downloadFile(params: any) {
    const fileid = params?.data?.jobmetadata?.fileid;
    this.ngxLoaderService.start();
  
    this.fileHandlerService.GetFileUrlById(fileid).subscribe(async res => {
      if (res && res.success) {
        const fileInfo = res.data;
        const fileUrl = `${fileInfo.domainurl}${fileInfo.filepath}`;
  
        try {
          const response = await fetch(fileUrl);
          const json = await response.json();
  
          if (Array.isArray(json) && json[0]?.type === 'Buffer' && Array.isArray(json[0].data)) {
            const uint8Array = new Uint8Array(json[0].data);
            const blob = new Blob([uint8Array], { type: 'application/zip' });
            saveAs(blob, fileInfo.filename || 'download.zip');
          } else {
            throw new Error('Unexpected file format');
          }
        } catch (err) {
          console.error('Error downloading file:', err);
          this.appCoreService.showMessage('File download failed or format is invalid.', '', 'error');
        } finally {
          this.ngxLoaderService.stop();
        }
      } else if (res && !res.success) {
        this.ngxLoaderService.stop();
        this.appCoreService.showMessage('File URL fetch failed.', '', 'error');
      }
    });
  }

  openJobValidationModal(cell: any) {
    // console.log("cell-other-error", cell)
    try {
      if (cell) {
        let ngbModalOptions: NgbModalOptions = {
          ariaLabelledBy: 'modal-basic-title',
          size: 'xl',
          backdrop: 'static',
          keyboard: false,
          centered: true
        };
        const modalRef = this.modalService.open(JobsValidationComponent, ngbModalOptions);
        modalRef.componentInstance.jobGuid = cell.jobguid;
        modalRef.componentInstance.jobCategory = cell.jobcategory;
      }
    } catch (err) {
      console.error('Error', err);
    }
  }

  openJobErrorModal(cell: any) {
    // console.log("cell-processingerror", cell)
    try {
      if (cell) {
        let ngbModalOptions: NgbModalOptions = {
          ariaLabelledBy: 'modal-basic-title',
          size: 'md',
          backdrop: 'static',
          keyboard: false,
          centered: true
        };
        const modalRef = this.modalService.open(JobsErrorComponent, ngbModalOptions);
        modalRef.componentInstance.jobGuid = cell.jobguid;
      }
    } catch (err) {
      console.error('Error', err);
    }
  }

  bindJobList(refresh = false) {
    try {
      this.ngxLoaderService.start();
      this.jobService.GetAllList({ refresh: refresh }).subscribe(res => {
        if (res && res.success) {
          this.ngxLoaderService.stop();
          // console.log("res_data--",res.data);
          this.rowDataJobQueue = res.data;
        } else if(res && !res.success) {
          this.appCoreService.showMessage(res.message,'Error','error');
          this.ngxLoaderService.stop();
        }
      })
    } catch (err) {
      this.ngxLoaderService.stop();
      console.error(err);
    }
  }

  refreshGrid() {
    this.ngxLoaderService.start();
    this.bindJobList(true);
    this.ngxLoaderService.stop();
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.setDomLayout("autoHeight");
    params.api.sizeColumnsToFit();
  }

}
